import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from '../services/subscription.service';
import { SubscriptionStatus } from '../../shared/models/subscription-status';

@Component({
  selector: 'dac-user-upgrade-subscription-notice',
  templateUrl: './user-upgrade-subscription-notice.component.html',
  styleUrls: ['./user-upgrade-subscription-notice.component.scss']
})
export class UserUpgradeSubscriptionNoticeComponent implements OnInit {

  public subscriptionSignupRoute:string[];
  public hasActiveSubscription:boolean;
  public terminationDate:Date;
  public trialPeriodEnded:boolean;

  constructor(private subscriptionService:SubscriptionService) { }

  ngOnInit() {
    this.subscriptionSignupRoute = this.subscriptionService.getSubscriptionPageRoute();
    // TODO: stephen need to get the subscription plan amount, and the termination date
    // account balance, 
    this.subscriptionService.getCurrentUserSubscription().then(subscription => {
      this.hasActiveSubscription = subscription.isActiveSubscription();
      this.terminationDate = subscription.endedAt;
      this.trialPeriodEnded = subscription.status == SubscriptionStatus.TRIAL_PERIOD_ENDED;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/user-upgrade-subscription-notice/user-upgrade-subscription-notice.component.ts